import React from 'react'
import PropTypes from 'prop-types'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

const Title = ({
    title,
    titleColor,
    titleTag,
    titleSizeMobile,
    titleSizeTablet,
    titleSizeLargeDesktop,
    titleFontFamily,
    titleSizeSmallDesktop,
    titleAlign
}) => {
    return (
        <Heading
            as={titleTag}
            maxWidth={{base: '100%', md: 'unset'}}
            margin="0"
            fontSize={{
                base: titleSizeMobile,
                md: titleSizeTablet,
                '2md': '24px',
                lg: titleSizeSmallDesktop,
                xl: titleSizeLargeDesktop
            }}
            fontFamily={titleFontFamily || 'caslon'}
            fontWeight="400"
            lineHeight="normal"
            textAlign={titleAlign}
            color={titleColor || 'black'}
        >
            {title}
        </Heading>
    )
}

Title.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleSizeLargeDesktop: PropTypes.string,
    titleSizeMobile: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleSizeSmallDesktop: PropTypes.string,
    titleSizeTablet: PropTypes.string,
    titleTag: PropTypes.string,
    titleAlign: PropTypes.string
}

export default Title
